var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { cx, css as emotionCss } from 'emotion';
import { BarWrapper, BarWrapperBackground, DataBar as Bar, Footnote, Header, ProgressBar as Component, } from './ProgressBar.styled';
import { small as smallCss } from '../styles/legacy';
import { small as smallCssCitron } from '../styles/citron';
import { getProgress, renderSection } from './private/_utils';
import { getAutomation, getDebug, useCitrusDebug, getStyleNames } from '@citrus/runtime';
import { isNotNullOrEmpty } from '@pcty/utils';
import { useTheme } from '@citrus/user';
var VERSION = '4.6.0';
var ProgressBar = React.forwardRef(function (_a, ref) {
    var _b, _c;
    var automationId = _a.automationId, _d = _a.background, background = _d === void 0 ? true : _d, className = _a.className, colorOverride = _a.colorOverride, css = _a.css, hidden = _a.hidden, progress = _a.progress, renderFootnote = _a.renderFootnote, renderHeader = _a.renderHeader, _e = _a.small, small = _e === void 0 ? false : _e, _f = _a.__TYPE, TYPE = _f === void 0 ? 'ProgressBarData' : _f, other = __rest(_a, ["automationId", "background", "className", "colorOverride", "css", "hidden", "progress", "renderFootnote", "renderHeader", "small", "__TYPE"]);
    var debug = useCitrusDebug();
    var isCitron = useTheme().citrus2022;
    if (hidden)
        return React.createElement(React.Fragment, null);
    progress = getProgress(progress);
    var classes = cx((_b = {},
        _b[emotionCss(css)] = isNotNullOrEmpty(css),
        _b), className || '');
    var emotionObj = (_c = {},
        _c[emotionCss(isCitron ? smallCssCitron : smallCss)] = small,
        _c);
    var barWrapperClasses = cx(emotionObj, className || '');
    var styleNames = {
        small: emotionObj[emotionCss(isCitron ? smallCssCitron : smallCss)],
    };
    var BarWrapperComponent = background ? BarWrapperBackground : BarWrapper;
    var barStyles = isNotNullOrEmpty(colorOverride)
        ? { width: progress + '%', background: colorOverride }
        : { width: progress + '%' };
    return (React.createElement(Component, __assign({ className: classes, ref: ref }, other, getAutomation(automationId), getDebug(debug, TYPE, VERSION)),
        renderSection(renderHeader, Header, getAutomation(automationId, 'header'), "".concat(progress, "% Complete")),
        React.createElement(BarWrapperComponent, { className: barWrapperClasses, styleNames: getStyleNames(styleNames) },
            React.createElement(Bar, { style: barStyles })),
        renderSection(renderFootnote, Footnote, getAutomation(automationId, 'footnote'))));
});
ProgressBar.defaultProps = {
    __TYPE: 'ProgressBarData',
};
export default ProgressBar;
